import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const code = searchParams.get('code');
    if (!code) {
      navigate('/auth?error=oauth_failed', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post('/api/auth/exchange-token', { code });
        // Cookie is now set by the API response — refresh auth context
        await refreshUser();
        const redirect = res.data.redirect || '/home';
        navigate(redirect, { replace: true });
      } catch {
        navigate('/auth?error=oauth_failed', { replace: true });
      }
    })();
  }, [searchParams, navigate, refreshUser]);

  return <LoadingScreen label="Completing sign in…" />;
}
